module.exports = __webpack_public_path__ + "static/media/backtick.c4674c91.svg";